/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TickerUiSettingsDto } from '../../models/ticker-ui-settings-dto';

export interface GetTickerUiSettings$Params {
  'X-API-Version'?: string;
}

export function getTickerUiSettings(http: HttpClient, rootUrl: string, params?: GetTickerUiSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<TickerUiSettingsDto>> {
  const rb = new RequestBuilder(rootUrl, getTickerUiSettings.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TickerUiSettingsDto>;
    })
  );
}

getTickerUiSettings.PATH = '/api/ticker-ui-settings';
